module.exports = "/_next/static/images/slide7-af57523637481a06c360cb23dea1a69a.webp";